function personName(person) {
  if (!person) return '';
  const named = String(person.fullName || '').trim();
  if (named) return named;
  return `${person.First || ''} ${person.Last || ''}`.trim();
}

function lastTenDigits(phone) {
  const digits = String(phone || '').replace(/\D/g, '');
  if (digits.length < 10) return '';
  return digits.slice(-10);
}

function tenantSearchSmsPayload(person, body) {
  const text = String(body || '').trim();
  const name = personName(person);
  if (!text) return { ok: false, reason: 'empty_body', name };
  if (!person || typeof person !== 'object') {
    return { ok: false, reason: 'no_recipient', name };
  }
  const peopleId = Number(person.id);
  const phoneDigits = lastTenDigits(person.Phone || person.phone);
  if (Number.isFinite(peopleId) && peopleId > 0) {
    return {
      ok: true,
      name,
      payload: {
        peopleId,
        ...(phoneDigits ? { phoneDigits } : {}),
        body: text,
      },
    };
  }
  if (!phoneDigits) return { ok: false, reason: 'no_phone', name };
  return {
    ok: true,
    name,
    payload: {
      peopleId: null,
      userId: null,
      phoneDigits,
      externalName: name,
      body: text,
    },
  };
}

function tenantSearchSmsTargets({ bulkActive, bulkList, selectedPerson } = {}) {
  if (bulkActive) {
    return (Array.isArray(bulkList) ? bulkList : []).filter(Boolean);
  }
  return selectedPerson ? [selectedPerson] : [];
}

function tenantSearchSmsNotice(result) {
  const name = (result && result.name) || 'This tenant';
  if (!result || result.ok === false) {
    const reason = result && result.reason;
    if (reason === 'empty_body') return 'Enter a message before sending.';
    if (reason === 'no_phone' || reason === 'no_recipient') {
      return 'No phone number to text.';
    }
    if (reason === 'pending_opt_in') {
      return `${name} has not opted in yet. Wait for YES or START.`;
    }
    if (reason === 'phone_mismatch') {
      return `${name} opted in on a different phone number.`;
    }
    if (reason === 'not_configured') return 'Texting is not set up on the server.';
    if (reason === 'not_found') return `${name} could not be found for texting.`;
    return `SMS to ${name} was not sent.`;
  }
  if (result.status === 'pending_opt_in') {
    return `Opt-in text sent to ${name}. The message goes out after they reply YES or START.`;
  }
  return `SMS sent to ${name}.`;
}

function tenantSearchSmsSummary(results) {
  const list = Array.isArray(results) ? results : [];
  if (!list.length) return 'No phone number to text.';
  if (list.length === 1) return tenantSearchSmsNotice(list[0]);
  if (list.every((row) => row && row.reason === 'empty_body')) {
    return 'Enter a message before sending.';
  }
  if (
    list.every(
      (row) => row && (row.reason === 'no_phone' || row.reason === 'no_recipient'),
    )
  ) {
    return 'No phone number to text.';
  }
  let sent = 0;
  let gated = 0;
  let waiting = 0;
  let failed = 0;
  for (const row of list) {
    if (row && row.ok && row.status === 'pending_opt_in') gated += 1;
    else if (row && row.ok) sent += 1;
    else if (row && row.reason === 'pending_opt_in') waiting += 1;
    else failed += 1;
  }
  const parts = [];
  if (sent) parts.push(`Sent ${sent}`);
  if (gated) parts.push(`Opt-in started for ${gated}`);
  if (waiting) parts.push(`${waiting} still waiting to opt in`);
  if (failed) parts.push(`${failed} not sent`);
  return `${parts.join('. ')}.`;
}

module.exports = {
  tenantSearchSmsPayload,
  tenantSearchSmsTargets,
  tenantSearchSmsSummary,
};
